import api from 'api'
import { z } from 'zod'

export const cancelContestedHoursRequestSchema = z.object({
  associationId: z.number(),
})

export type CancelContestedHoursRequest = z.infer<
  typeof cancelContestedHoursRequestSchema
>

export const cancelContestedHoursRequest = async (
  request: CancelContestedHoursRequest
): Promise<void> => {
  const parsedRequest = cancelContestedHoursRequestSchema.parse(request)

  await api.post('/admin/dayforce/cancel_contested_hours_request', {
    associationId: parsedRequest.associationId,
  })
}
